module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/p65Z8m/tc-custom/9781939867742.jpg?1714677984386",
      "alt": "This image is the cover for the book Dune: House Harkonnen Vol. 2, Dune: House Harkonnen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dune: House Harkonnen Vol. 2, Dune: House Harkonnen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Spanning from Arrakis to Wallach IX, formative moments from major characters’ past in the Dune universe come to light driven by the ruthless machinations of House Harkonnen! Chaos ensues across planets with tense rescue missions, impossible choices, meanwhile events on Ix turn explosive, and Bene Gesserit plotting finally comes to fruition. As the Harkonnens brutality abounds on Arrakis, Liet and Warrick are pitted against each other in the name of love, Leto finds himself in a fateful meeting elsewhere, and Duncan takes a significant step toward who he’s destined to be... The tension rises in the thrilling prequel adaptation by authors Brian Herbert& Kevin J. Anderson, artist Fran Galán (Creepshow), and colorist Patricio Delpeche (Fissure), where deadly choices and conflicts will shape the future of Arrakis and the entire Dune universe! Collects Dune: House Harkonnen #5–8.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brian Herbert, Kevin J. Anderson, Fran Galán\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0